import { postCriarAfericao } from '../offline/api';
import { getTurnoAtual } from '../utils/dateUtils';

export async function iniciarAfericao(empresa) {
  const empresaId = empresa.id || empresa.Id;
  const timeZoneId = empresa.timeZoneId || empresa.TimeZoneId || 'America/Sao_Paulo';
  const turno = getTurnoAtual(timeZoneId);

  // Obter localização atual
  const position = await new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: true,
      timeout: 10000
    });
  });

  const localizacaoLat = position.coords.latitude;
  const localizacaoLng = position.coords.longitude;

  try {
    const response = await postCriarAfericao({
      empresaId,
      turno,
      localizacaoLat,
      localizacaoLng
    });
    
    // Retornar o ID da aferição criada
    return response.id;
  } catch (error) {
    console.error('Erro ao criar aferição:', error);
    throw new Error('Erro ao criar aferição. Tente novamente.');
  }
}

